module.exports = __webpack_public_path__ + "static/media/shell32_142.b307565c.ico";